import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalenderAdd"><Path d="M8.5 2H7V4H3V21H12V19.5H4.5V10H19.5V12H21V4H17V2H15.5V4H8.5V2Z" fill="currentColor"/><Path d="M18.5 14H17V17.25H13.75V18.75H17V22H18.5V18.75H21.75V17.25H18.5V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderAdd;
